import React, { Component } from 'react';
import PageHelmet from './Helmet';
import Breadcrumb from './Breadcrumb';
import CounterOne from './CounterOne';
import Testimonial from './Testimonial';
import BrandTwo from './BrandTwo';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';
import Header from '../../../Layout/Main/header/Header';
import Footer from '../../../Layout/Main/footer/FooterTwo';

class LongDistance extends Component {
	render() {
		let title = 'Long Distance',
			description =
				'The moving process can be daunting and overwhelming for you either you are moving to your first house or you are moving to your dream home. Every step of the moving process can be very stressful from packing up your things to moving them to the new location. Long-distance moving is even more stressful because all the time you are worried about the safety and security of your possessions when traveling to a long distance. So it’s always better to avail of the services of a trusted and reliable moving company when you are planning a long-distance move. With over 10 years of combined experience in helping families for long-distance moving, Moonline know how to make your move effortless and how to ease your troubled mind. We handle all your personal belongings with extra care and ensure safe packing and transportation. Not only that we also help you set up your things in your new home.';
		return (
			<React.Fragment>
				<PageHelmet pageTitle='Long Distance' />

				<Header headertransparent='header--transparent' colorblack='color--black' logoname='logo.png' />
				{/* Start Breadcrump Area */}
				
				{/* End Breadcrump Area */}

				{/* Start About Area  */}
				<div className='rn-about-area ptb--120 bg_color--1'>
					<div className='rn-about-wrapper'>
						<div className='container'>
							<div className='row row--35 align-items-center'>
								<div className='col-lg-7'>
									<div className='about-inner inner'>
										<div className='section-title'>
										<Breadcrumb title={'Long Distance'} />
											<h2 className='title'>{title}</h2>
											<p className='description'>{description}</p>
										</div>
										<div className='row mt--30'>
											<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
												<div className='about-us-list'>
													<h3 className='title'>Your Trusted Moving Partners</h3>
													<p>
														When you are moving long-distance then you need a company that you can trust. Moonline will be there to assist on each and every step of your move to make you feel comfortable and relaxed. Unlike other companies, we don’t charge any hidden fee
														to our clients and our sole aim is to make your move secure and stress-free. We also deliver your belongings to your desired destination at the right time. We set flat-rate prices and guaranteed delivery dates to make long-distance moving
														easier and affordable for you.
													</p>
													<p>
														If you are planning to move anywhere in Canada then we are always available at your service. We have a dedicated team of long-distance movers to provide you efficient and reliable moving service. We have already helped a lot of families and
														they are all satisfied with our services.
													</p>
												</div>
											</div>
											<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
												<div className='about-us-list'>
													<h3 className='title'>WHAT DO WE DO?</h3>
													<h4>Packing</h4>
													<p>We help you to pack your supplies in the securest possible ways so that they are safe and easy to move.</p>

													<h4>Loading</h4>
													<p>We safely load your belongings into our moving trucks to ensure that there is no damage caused to your belongings.</p>

													<h4>Moving</h4>
													<p>During the move, we ensure that your belongings are safe and secure until they arrive at the new destination.</p>

													<h4>Unloading</h4>
													<p>When arrived at the destination our experts will unload all your stuff from the trucks and will place them in your.</p>

													<h4>Unpacking</h4>
													<p>We will unpack all the boxes and will put your furniture at your desired places. Our job isn't done until you're settled in your new home.</p>
													<p>
														We handle local, and cross-country moves. Whether you want to move your home or you want to move your office, we got you covered. If you are worried about the moving cost then we have flexible packages and flex payment for you depending upon
														the size of your home and business. You can contact us right now to get a free estimate for your move.
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div className='backto-top'>
					<ScrollToTop showUnder={160}>
						<FiChevronUp />
					</ScrollToTop>
				</div>
				{/* End Back To Top */}

				<Footer />
			</React.Fragment>
		);
	}
}
export default LongDistance;
